import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, type }) => {
  const { isAuthenticated, userType, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-rose-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    if (type === 'admin') {
      return <Navigate to="/admin/login" state={{ from: location }} replace />;
    } else if (type === 'operator') {
      return <Navigate to="/operator/login" state={{ from: location }} replace />;
    } else if (type === 'affiliate') {
      return <Navigate to="/affiliate/login" state={{ from: location }} replace />;
    } else if (type === 'lawyer') {
      return <Navigate to="/lawyer/login" state={{ from: location }} replace />;
    }
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Check user type authorization
  if (type === 'admin' && userType !== 'admin') {
    return <Navigate to="/admin/login" replace />;
  }

  // Mass-messaging-only logins never reach another page.
  if (user?.role === 'mass_sender' && location.pathname !== '/admin/mass-message') {
    return <Navigate to="/admin/mass-message" replace />;
  }

  if (type === 'operator' && !['operator', 'admin'].includes(userType)) {
    return <Navigate to="/operator/login" replace />;
  }

  if (type === 'affiliate' && userType !== 'affiliate') {
    return <Navigate to="/affiliate/login" replace />;
  }

  if (type === 'lawyer' && !['lawyer', 'admin'].includes(userType)) {
    return <Navigate to="/lawyer/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
